import { render, staticRenderFns } from "./PaymethodForm.vue?vue&type=template&id=be08c9be&"
import script from "./PaymethodForm.vue?vue&type=script&lang=js&"
export * from "./PaymethodForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports